import { render, staticRenderFns } from "./EditarCategoria.vue?vue&type=template&id=37b921da&"
import script from "./EditarCategoria.vue?vue&type=script&lang=js&"
export * from "./EditarCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports